export enum ChargeBearerTypeCode {
  CRED = 'CRED',
  DEBT = 'DEBT',
  SHAR = 'SHAR',
  SLEV = 'SLEV',
}
